import { render, staticRenderFns } from "./BacklinkChangeToDomainRefusedForm.vue?vue&type=template&id=38c6a870&scoped=true&"
import script from "./BacklinkChangeToDomainRefusedForm.vue?vue&type=script&lang=js&"
export * from "./BacklinkChangeToDomainRefusedForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38c6a870",
  null
  
)

/* custom blocks */
import block0 from "./BacklinkChangeToDomainRefusedForm.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports